import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import { PrimaryLayout, SiteHeader, SkipLink, MainContent } from './MainLayout.style';
import TopNavBar from '../TopNavBar';
import ExamBanner from '@components/Component/Exams/ExamBanner';

const MainLayout = ({ children, isLoading }) => {
  const [showBanner, setShowBanner] = useState(false);

  if (isLoading) {
    return <LoadingIndicator isLoading={isLoading} />;
  }

  return (
    <PrimaryLayout
      showBanner={showBanner}
      className={`primary-layout${showBanner ? ' show-banner' : ''}`}
    >
      <SiteHeader>
        <SkipLink href="#main-content">Skip to main content</SkipLink>
        <ExamBanner onShowBannerChange={setShowBanner} />
      </SiteHeader>
      <TopNavBar />
      <MainContent id="main-content" tabIndex={-1}>
        {children}
      </MainContent>
    </PrimaryLayout>
  );
};

MainLayout.propTypes = {
  children: PropTypes.element,
  isLoading: PropTypes.bool,
};

export default MainLayout;
